export enum IdType{
    CEDULA = "CC",
    TARJETA_IDENTIDAD = 'TI',
    REGISTRO_CIVIL = 'RC',
    PASAPORTE = 'PT',
    CEDULA_EXTRANGERIA = 'CE',
    IDENTIDAD_EXTRANGERA = 'IE',
    EMPTY = ''
}